export default class VoyageValidatorData {
  constructor(
    id,
    draft,
    tss,
    serviceSpeed,
    cruiseSpeed,
    wind,
    wave,
    trs,
    landProximity,
  ) {
    this.id = id;
    this.draft = draft;
    this.tss = tss;
    this.serviceSpeed = serviceSpeed;
    this.cruiseSpeed = cruiseSpeed;
    this.wind = wind;
    this.wave = wave;
    this.trs = trs;
    this.landProximity = landProximity;
  }
}
